<template>
  <div id="app">
    <Header/>
    <div style="min-height: 800px">
       <router-view/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import  Footer  from './components/pubilc/footer/index'
import  Header  from './components/pubilc/header/index'
export default {
  name: 'App',
  data () {
    return {

    }
  },
  components: {
    Footer,
    Header
  },
  mounted(){

  },
}
</script>

<style>
#app {
  font-family:PingFangSC-Regular,PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue